const ReportReason = {
	COPYRIGHT_INFRINGEMENT: 'copyright_infringement',
	NUDITY: 'nudity',
	OFFENSIVE: 'offensive',
	UGLY: 'ugly',
} as const;

export default ReportReason;
